module.exports = __webpack_public_path__ + "media/start-us-up-now-anbp-2.jpg";